<template>
    <ValidationObserver ref="changeInfoForm">
        <b-container class="mt-5">
            <b-row>
                <b-col>
                    <b-card class="p-4">
                        <b-row class="text-center mb-4">
                            <b-col cols="12" class="d-flex align-items-center justify-content-between">
                                <img src="../../../assets/img/BAU_Logo.png" height="75" alt="BAU Logo"/>
                                <h6 class="mb-0 bg-light" v-html="$t('bau_inspiration_text')"></h6>
                            </b-col>
                            <b-col>
                                <h3 class="font-weight-bold">{{ $t('change_of_information_request_form') }}</h3>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <ValidationProvider v-slot="{ errors }" name="student_name" rules="required">
                                    <b-form-group :label="$t('student_name')">
                                        <b-form-input v-model="form.student_name" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>

                        <h5 class="mt-4 section-title">{{ $t('previous_information') }}</h5>
                        <b-row>
                            <b-col cols="12" md="4">
                                <ValidationProvider v-slot="{ errors }" name="previous_phone" rules="required">
                                    <b-form-group :label="$t('phone')">
                                        <b-form-input v-model="form.previous.phone" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="4">
                                <ValidationProvider v-slot="{ errors }" name="previous_email" rules="required|email">
                                    <b-form-group :label="$t('email')">
                                        <b-form-input v-model="form.previous.email" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="4">
                                <ValidationProvider v-slot="{ errors }" name="previous_student_id" rules="required">
                                    <b-form-group :label="$t('student_id')">
                                        <b-form-input v-model="form.previous.student_id" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('street_1')">
                                    <b-form-input v-model="form.previous.street1"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('street_2')">
                                    <b-form-input v-model="form.previous.street2"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group :label="$t('city')">
                                    <b-form-input v-model="form.previous.city"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group :label="$t('state')">
                                    <b-form-input v-model="form.previous.state"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group :label="$t('zip_code')">
                                    <b-form-input v-model="form.previous.zip_code"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <h5 class="mt-4 section-title">{{ $t('current_information') }}</h5>
                        <b-row>
                            <b-col cols="12" md="4">
                                <ValidationProvider v-slot="{ errors }" name="current_phone" rules="required">
                                    <b-form-group :label="$t('phone')">
                                        <b-form-input v-model="form.current.phone" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="4">
                                <ValidationProvider v-slot="{ errors }" name="current_email" rules="required|email">
                                    <b-form-group :label="$t('email')">
                                        <b-form-input v-model="form.current.email" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="4">
                                <ValidationProvider v-slot="{ errors }" name="current_student_id" rules="required">
                                    <b-form-group :label="$t('student_id')">
                                        <b-form-input v-model="form.current.student_id" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('street_1')">
                                    <b-form-input v-model="form.current.street1"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('street_2')">
                                    <b-form-input v-model="form.current.street2"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group :label="$t('city')">
                                    <b-form-input v-model="form.current.city"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group :label="$t('state')">
                                    <b-form-input v-model="form.current.state"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group :label="$t('zip_code')">
                                    <b-form-input v-model="form.current.zip_code"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mt-4">
                            <b-col md="6">
                                <ValidationProvider v-slot="{ errors }" name="student_signature" rules="required">
                                    <b-form-group :label="$t('student_signature')">
                                        <b-form-input v-model="form.student_signature" :state="errors.length ? false : null"></b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('date')">
                                    <select-date v-model="form.student_date"/>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <h5 class="mt-4 section-title">{{ $t('for_bau_employee_use') }}</h5>
                        <b-row class="mt-4">
                            <b-col cols="12">
                                <b-form-group :label="$t('processed_by')">
                                    <b-form-input v-model="form.processed_by"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('student_signature')">
                                    <b-form-input v-model="form.employee_signature"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group :label="$t('date')">
                                    <select-date v-model="form.employee_date"/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </ValidationObserver>
</template>

<script>
import moment from 'moment';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            currentDate: moment().format('YYYY-MM-DD'),
            form: {
                student_name: '',
                previous: {
                    phone: '',
                    email: '',
                    student_id: '',
                    street1: '',
                    street2: '',
                    city: '',
                    state: '',
                    zip_code: ''
                },
                current: {
                    phone: '',
                    email: '',
                    student_id: '',
                    street1: '',
                    street2: '',
                    city: '',
                    state: '',
                    zip_code: ''
                },
                student_signature: '',
                student_date: '',
                processed_by: '',
                employee_signature: '',
                employee_date: ''
            }
        };
    },
    methods: {}
};
</script>

<style scoped>
.section-title {
    display: inline-block;
    border-bottom: 2px solid #000;
    padding-bottom: 5px;
    margin-bottom: 15px;
}
</style>
